import { render } from "./VariablesCSS.vue?vue&type=template&id=8b6e561c"
import script from "./VariablesCSS.vue?vue&type=script&lang=js"
export * from "./VariablesCSS.vue?vue&type=script&lang=js"

import "./VariablesCSS.vue?vue&type=style&index=0&id=8b6e561c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__